<template>
  <ul v-if="!mobile" ref="sidebar" class="navbar-nav sidebar sidebar-dark accordion akkurate-dark-gradient">
    <!-- Sidebar - Brand -->
    <a class="sidebar-brand d-flex align-items-start justify-content-center" href="/">
      <!-- <div class="sidebar-brand-icon">
                <font-awesome-icon :icon="['fas', 'layer-group']" />
            </div> -->
      <!-- image -->
      <img height="50px" src="../../../assets/img/logo.png" />
      <div class="sidebar-brand-text mx-3 mb-0 pb-0 text-start mt-auto">
        <div>AKKURATEBanc</div>
        <div style="color:#a4f5ec;" class="text-xs">{{ this.user_branch }}</div>
      </div>

    </a>

    <!-- Divider -->
    <hr class="sidebar-divider mt-0" />

    <!-- Nav Item - Dashboard -->
    <li class="nav-item" :class="{ active: home }" v-if="dashboardVisible">
      <a class="nav-link" href="/">
        <font-awesome-icon :icon="['fas', 'house-damage']" /><span>Dashboard</span>
      </a>
    </li>

    <hr class="sidebar-divider" v-if="memberManagementSectionVisible" />

    <div class="sidebar-heading" v-if="memberManagementSectionVisible">Member Management</div>

    <!-- Memebers -->
    <b-nav-item v-b-toggle.collapse-3 :class="{ active: members }" v-if="membersNavVisible">
      <font-awesome-icon :icon="['fas', 'users']" /><span>Members</span>
      <b-collapse id="collapse-3" :visible="memberVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="member_management_add"
            class="collapse-item"
            :class="{ active: addMember }"
            href="/members/create"
            >Create Member</b-link
          >
          <b-link
            v-if="member_management_view"
            class="collapse-item"
            :class="{ active: allMember }"
            href="/members"
          >
            <CustomTooltip :message="memberHoverDetailDiplay" :is-html="true" :background="'rgba(1, 134, 114, 0.6)'"
              :color="'#ffffff'" :offsetY="30">
              All Members
              <small class="ms-1" :class="statusBadge('Pending')">{{ memberData.pending_customer_count }}</small>
              <small class="ms-1" :class="statusBadge('Rejected')">{{ memberData.rejected_customer_count }}</small>

            </CustomTooltip>
          </b-link>
          <b-link
            v-if="member_management_import"
            class="collapse-item"
            :class="{ active: memberImport }"
            href="/members/import"
            >Imports</b-link
          >
          <b-link
            v-if="member_management_view"
            class="collapse-item"
            :class="{ active: roTransfer }"
            href="/members/ro/transfer"
            >Ro Transfer</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" v-if="productsNavVisible" />

    <!-- Member Accounts -->
    <b-nav-item v-b-toggle.collapse-4 :class="{ active: memacc }" v-if="productsNavVisible">
      <font-awesome-icon :icon="['fas', 'user-circle']" /><span>Products</span>
      <b-collapse id="collapse-4" :visible="memaccVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="account_management_add"
            class="collapse-item"
            :class="{ active: addMemAcc }"
            href="/members/account/create"
            >Create Product</b-link
          >
          <b-link
            v-if="account_management_view"
            class="collapse-item"
            :class="{ active: allMemAcc }"
            href="/members/account"
          >
            <CustomTooltip :message="allProductHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Products
              <!-- <small class="ms-1" :class="statusBadge('Approved')">{{ productData.account.active }}</small> -->
              <small class="ms-1" :class="statusBadge('Pending')">{{ productSummary.pending }}</small>
              <small class="ms-1" :class="statusBadge('Rejected')">{{ productSummary.closed }}</small>
            </CustomTooltip>
          </b-link>
          <b-link
            v-if="account_management_view"
            class="collapse-item"
            :class="{ active: importMembers }"
            href="/members/account/imports"
            >Imports</b-link
          >
          <b-link
            v-if="account_management_view"
            class="collapse-item"
            :class="{ active: balanceTransferBulk }"
            href="/members/account/balance-transfer/bulk"
            target="_self"
            >Balance Transfer (Bulk)</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" v-if="commission_management_setup || commission_management_pay" />
    <!-- Commission -->
    <b-nav-item v-b-toggle.collapse-commission :class="{ active: commission }" v-if="commission_management_setup || commission_management_pay">
      <font-awesome-icon :icon="['fas', 'hand-holding-dollar']" /><span>Commission</span>
      <b-collapse id="collapse-commission" :visible="commissionVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="commission_management_setup"
            class="collapse-item"
            :class="{ active: commissionSetup }"
            href="/members/account/commission/setup"
            target="_self"
            >Setup commission</b-link
          >
          <b-link
            v-if="commission_management_pay"
            class="collapse-item"
            :class="{ active: commissionPay }"
            href="/members/account/commission/pay"
            target="_self"
            >Pay Commission</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" v-if="interest_management_setup || interest_management_pay" />
    <!-- Interest & Dividend -->
    <b-nav-item v-b-toggle.collapse-interest-dividend :class="{ active: interestDividend }" v-if="interest_management_setup || interest_management_pay">
      <font-awesome-icon :icon="['fas', 'coins']" /><span>Interest &amp; Dividend</span>
      <b-collapse id="collapse-interest-dividend" :visible="interestDividendVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="interest_management_setup"
            class="collapse-item"
            :class="{ active: interestSetup }"
            href="/members/account/interest/setup"
            target="_self"
            >Setup Interest</b-link
          >
          <b-link
            v-if="interest_management_pay"
            class="collapse-item"
            :class="{ active: interestPay }"
            href="/members/account/interest/pay"
            target="_self"
            >Pay Interest</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>

    <!-- Divider -->
    <hr class="sidebar-divider" v-if="transactionsSectionVisible">
    <div class="sidebar-heading" v-if="transactionsSectionVisible">
      Transactions
    </div>
    <!-- Operations -->
    <b-nav-item v-b-toggle.collapse-5 :class="{ active: transaction }" v-if="transactionsSectionVisible">
      <font-awesome-icon :icon="['fas', 'money-bill']" /><span>Deposit/Withdrawal</span>
      <b-collapse id="collapse-5" :visible="transVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="transaction_management_deposit"
            class="collapse-item"
            :class="{ active: depositTransaction }"
            href="/transactions/deposit"
            >Deposit</b-link
          >
          <b-link
            v-if="transaction_management_withdrawal"
            class="collapse-item"
            :class="{ active: withdrawalTransaction }"
            href="/transactions/withdrawal"
            >Withdrawal</b-link
          >
          <!-- <b-link class="collapse-item" :class="{ active: bulkTransaction }" href="/transactions/deposits/bulk">Bulk
            Deposits</b-link> -->
          <!-- <b-link class="collapse-item" :class="{ active: bulkWithdrawals }" href="/transactions/withdrawals/bulk">Bulk
            Withdrawals</b-link> -->
          <b-link
            v-if="transaction_management_all_view"
            class="collapse-item"
            :class="{ active: allTransaction }"
            href="/transactions/all-deposit-withdrawal"
          >
            <CustomTooltip :message="depositAndWithdrawalrHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Deposits /<br /> Withdrawals
              <small class="ms-1" :class="statusBadge('Pending')">{{ depositAndWithdrawalData.count.pending }}</small>
              <small class="ms-1" :class="statusBadge('Rejected')">{{ depositAndWithdrawalData.count.reversed }}</small>
            </CustomTooltip>
          </b-link>

          <b-link
            v-if="transaction_management_deposit || transaction_management_withdrawal"
            class="collapse-item"
            :class="{ active: chequeProcessing }"
            href="/transactions/cheque-processing"
            >Cheque Processing</b-link
          >

          <b-link
            v-if="transaction_management_import"
            class="collapse-item"
            :class="{ active: transactionImports }"
            href="/transactions/imports"
            >Imports</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" v-if="cdc_open_close || cdc_approve_reject" />
    <!-- Cashier -->
    <b-nav-item v-b-toggle.collapse-cashier :class="{ active: cashier }" v-if="cdc_open_close || cdc_approve_reject">
      <font-awesome-icon :icon="['fas', 'cash-register']" /><span>Cashier</span>
      <b-collapse id="collapse-cashier" :visible="cashierVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link v-if="cdc_open_close" class="collapse-item" :class="{ active: cdc }" href="/cashier/daily-closure">Daily Closure (CDC)</b-link>
          <b-link v-if="cdc_approve_reject" class="collapse-item" :class="{ active: cdcApprovals }" href="/cashier/cdc-approvals">CDC Approvals</b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" v-if="asset_register_manage || asset_register_reports" />
    <!-- Fixed Assets -->
    <b-nav-item v-b-toggle.collapse-fixed-assets :class="{ active: fixedAssets }" v-if="asset_register_manage || asset_register_reports">
      <font-awesome-icon :icon="['fas', 'warehouse']" /><span>Fixed Assets</span>
      <b-collapse id="collapse-fixed-assets" :visible="fixedAssetsVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link v-if="asset_register_manage" class="collapse-item" :class="{ active: assets }" href="/assets">Asset Register</b-link>
          <b-link v-if="asset_register_manage" class="collapse-item" :class="{ active: assetCategories }" href="/asset-categories">Asset Categories</b-link>
          <div class="collapse-item text-uppercase small fw-bold mt-2" style="pointer-events: none; color: inherit;">
            Reports
          </div>
          <b-link v-if="asset_register_reports" class="collapse-item" :class="{ active: assetRegisterReport }" href="/fixed-assets/reports/register">
            Asset Register Report
          </b-link>
          <b-link v-if="asset_register_reports" class="collapse-item" :class="{ active: assetMovementHistoryReport }" href="/fixed-assets/reports/movements">
            Asset Movement History
          </b-link>
          <b-link v-if="asset_register_reports" class="collapse-item" :class="{ active: depreciationScheduleReport }" href="/fixed-assets/reports/depreciation-schedule">
            Depreciation Schedule
          </b-link>
          <b-link v-if="asset_register_reports" class="collapse-item" :class="{ active: nbvPerBranchReport }" href="/fixed-assets/reports/nbv-per-branch">
            NBV per Branch
          </b-link>
          <b-link v-if="asset_register_reports" class="collapse-item" :class="{ active: disposedAssetsReport }" href="/fixed-assets/reports/disposed">
            Disposed Assets
          </b-link>
        </div>
      </b-collapse>
    </b-nav-item>
    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block" v-if="operationsSectionVisible">

    <b-nav-item v-b-toggle.collapse-6 :class="{ active: operation }" v-if="operationsSectionVisible">
      <font-awesome-icon :icon="['fas', 'briefcase']" /><span>Operations</span>
      <b-collapse id="collapse-6" :visible="operationsVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="operation_management_standing_order_view"
            class="collapse-item"
            :class="{ active: standing_order }"
            href="/standing-order"
            >Standing
            Orders</b-link>
          <b-link
            v-if="operation_management_fixed_deposit_view"
            class="collapse-item"
            :class="{ active: fdScheme }"
            href="/investment/fixed-deposit-scheme"
            >Fixed
            Deposit Scheme</b-link>
          <b-link
            v-if="operation_management_fixed_deposit_view"
            class="collapse-item"
            :class="{ active: fixed_deposit }"
            href="/investment/fixed-deposit"
          >
            <CustomTooltip :message="fixedDepositHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              Fixed Term Deposits
              <small class="" :class="statusBadge('Pending')">{{ fixed_deposit_summary[0]?.count }}</small>
              <small class="" :class="statusBadge('Rejected')">{{ fixed_deposit_summary[2]?.count }}</small>
            </CustomTooltip>
          </b-link>
          <b-link
            v-if="operation_management_fixed_deposit_view"
            class="collapse-item"
            :class="{ active: fixed_deposit_trans }"
            href="/investment/fixed-deposit/transactions"
            >Fixed Term Transactions</b-link
          >

          <b-link
            v-if="operation_management_import"
            class="collapse-item"
            :class="{ active: operationImport }"
            href="/operations/imports"
            >Imports</b-link
          >
          <b-link
            v-if="system_management_view_control"
            class="collapse-item"
            :class="{ active: allTransaction }"
            href="/reports/controls/user-coa-tracker"
            >Collection Tracker</b-link
          >

          <b-link
            v-if="operation_management_fixed_deposit_view"
            class="collapse-item"
            :class="{ active: termDepositsReports }"
            href="/reports/fixed-term-deposits"
            >Term Deposits Reports</b-link
          >
          <b-link
            v-if="operation_management_fixed_deposit_view"
            class="collapse-item"
            :class="{ active: termTransactionsReports }"
            href="/reports/fixed-term-transactions"
            >Term Transactions Reports</b-link
          >
          <b-link
            v-if="transaction_management_deposit || transaction_management_withdrawal"
            class="collapse-item"
            :class="{ active: otherPaymentReceipts }"
            href="/other-receipt-payment"
            >Other Receipt/Payments</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider d-none d-md-block" v-if="vouchersSectionVisible" />

    <b-nav-item v-b-toggle.collapse-7 :class="{ active: voucher }" v-if="vouchersSectionVisible">
      <font-awesome-icon :icon="['fas', 'book']" /><span>Vouchers</span>
      <b-collapse id="collapse-7" :visible="voucherVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="voucher_management_add"
            class="collapse-item"
            :class="{ active: addVoucher }"
            href="/voucher/create"
            >Create Voucher</b-link
          >
          <b-link
            v-if="voucher_management_view"
            class="collapse-item"
            :class="{ active: voucherIndex }"
            href="/voucher"
          >
            <CustomTooltip :message="allVoucherHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Vouchers
              <small class="ms-1" :class="statusBadge('Approved')">{{ allVoucherData.Approved.count }}</small>
              <small class="ms-1" :class="statusBadge('Pending')">{{ allVoucherData.Pending.count }}</small>
              <!-- <small class="ms-1" :class="statusBadge('Rejected')">{{ allJournalsData.closedCount }}</small> -->
            </CustomTooltip>
          </b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider d-none d-md-block" v-if="journalsSectionVisible" />

    <b-nav-item v-b-toggle.collapse-8 :class="{ active: journal }" v-if="journalsSectionVisible">
      <font-awesome-icon :icon="['fas', 'tasks']" /><span>Journals</span>
      <b-collapse id="collapse-8" :visible="journalVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="journal_management_add"
            class="collapse-item"
            :class="{ active: addJournal }"
            href="/journal/create"
            >Create Journal</b-link
          >
          <b-link
            v-if="journal_management_add"
            class="collapse-item"
            :class="{ active: addOpeningOrClosingJournal }"
            href="/journal/create-opening-closing"
            >Financial Year Transition</b-link
          >
          <b-link
            v-if="journal_management_view"
            class="collapse-item"
            :class="{ active: journalIndex }"
            href="/journal"
          >
            <CustomTooltip :message="allJournalsHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Journals
              <small class="ms-1" :class="statusBadge('Approved')">{{ allJournalsData.Approved.count }}</small>
              <small class="ms-1" :class="statusBadge('Pending')">{{ allJournalsData.Pending.count }}</small>
              <!-- <small class="ms-1" :class="statusBadge('Rejected')">{{ allJournalsData.closedCount }}</small> -->
            </CustomTooltip>
          </b-link>
          <b-link
            v-if="journal_management_transfer"
            class="collapse-item"
            :class="{ active: journalTransferIndex }"
            href="/journal/transfer"
            >Member Transfer</b-link
          >
          <b-link
            v-if="journal_management_add"
            class="collapse-item"
            :class="{ active: journalImport }"
            href="/journal/import"
            >Import</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider d-none d-md-block" v-if="loansSectionVisible" />
    <div class="sidebar-heading" v-if="loansSectionVisible">Loans</div>
    <!-- Loan -->
    <b-nav-item v-b-toggle.collapse-9 :class="{ active: loan }" v-if="loansSectionVisible">
      <font-awesome-icon :icon="['fas', 'hand-holding']" /><span>Loans</span>
      <b-collapse id="collapse-9" :visible="loanVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="loan_management_view"
            class="collapse-item"
            :class="{ active: allLoans }"
            href="/loans"
          >
            <CustomTooltip :message="allLoansHoverDetailDiplay" :max-width="'300px'" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Loans
              <small class="ms-1" :class="statusBadge('Approved')">{{ allLoansData.runningCount }}</small>
              <small class="ms-1" :class="statusBadge('Pending')">{{ allLoansData.pendingCount }}</small>
              <small class="ms-1" :class="statusBadge('Rejected')">{{ allLoansData.closedCount }}</small>
            </CustomTooltip>
          </b-link>
          <b-link
            v-if="loan_management_add"
            class="collapse-item"
            :class="{ active: loanTransaction }"
            href="/loans/transactions"
            >All Transactions</b-link
          >
          <b-link
            v-if="loan_management_add"
            class="collapse-item"
            :class="{ active: addLoan }"
            href="/loans/application"
            >Loan Application</b-link
          >
          <b-link
            v-if="loan_management_repayment"
            class="collapse-item"
            :class="{ active: repayLoan }"
            href="/loans/repayments"
            >Loan Repayments</b-link
          >
          <b-link
            v-if="loan_management_calculator"
            class="collapse-item"
            :class="{ active: loanCal }"
            href="/loans/calculator"
            >Loan Calculator</b-link
          >
          <b-link
            v-if="loan_management_view_scheme"
            class="collapse-item"
            :class="{ active: loanScheme }"
            href="/loans/scheme"
            >Loan Schemes</b-link
          >
          <!-- <b-link class="collapse-item" :class="{ active: loanImport }" href="/loans/import">Loan Imports</b-link> -->
          <!-- <b-link class="collapse-item" :class="{ active: loanBulkReymentsUpload }" href="/loans/bulk/repayments/upload">Repayment Imports</b-link> -->
          <b-link
            v-if="loan_management_import"
            class="collapse-item"
            :class="{ active: loanImports }"
            href="/loans/import"
            >Imports</b-link
          >

        </div>
      </b-collapse>
    </b-nav-item>

    <!-- Divider -->
    <hr class="sidebar-divider" v-if="financial_management_view_coa" />

    <!-- Heading --> 
    <div class="sidebar-heading" v-if="financial_management_view_coa">Financials</div>

    <!-- Budgets -->
    <hr class="sidebar-divider" v-if="budgetsSectionVisible" />
    <div class="sidebar-heading" v-if="budgetsSectionVisible">Budgets</div>

    <b-nav-item v-b-toggle.collapse-budgets :class="{ active: budgets }" v-if="budgetsSectionVisible">
      <font-awesome-icon :icon="['fas', 'coins']" /><span>Budgets</span>
      <b-collapse id="collapse-budgets" :visible="budgetsVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="budgetsManageVisible || budgetsApprovalsVisible"
            class="collapse-item"
            :class="{ active: budgetsList }"
            href="/budgets"
          >
            Budgets (List)
          </b-link>
          <b-link
            v-if="budgetsManageVisible"
            class="collapse-item"
            :class="{ active: budgetsCreate }"
            href="/budgets/new"
          >
            Create Budget
          </b-link>
          <b-link
            v-if="budgetsManageVisible"
            class="collapse-item"
            :class="{ active: budgetsLines }"
            :href="budgetsLinesHref"
          >
            Budget Lines
          </b-link>
          <b-link
            v-if="budgetsApprovalsVisible"
            class="collapse-item"
            :class="{ active: budgetsApprovals }"
            :href="budgetsApprovalsHref"
          >
            Budget Approvals
          </b-link>
          <b-link class="collapse-item" :class="{ active: budgetsDashboard }" :href="budgetsDashboardHref">
            Budget Dashboard
          </b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider my-3" v-if="budgetsSectionVisible && financial_management_view_coa" />

    <!-- COA Management -->
    <b-nav-item v-b-toggle.collapse-1 v-if="financial_management_view_coa" :class="{ active: accounts }">
      <font-awesome-icon :icon="['fas', 'chart-bar']" /><span>Chart Of Accounts</span>
      <b-collapse :visible="accountsVisible" id="collapse-1">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: allAccountTypes }" v-if="financial_management_view_coa_type" href="/chart-of-accounts/account-types">COA
            Types</b-link>
          <b-link class="collapse-item" :class="{ active: allCoa }" href="/chart-of-accounts">Accounts</b-link>
          <b-link
            v-if="financial_management_import_coa"
            class="collapse-item"
            :class="{ active: coaImports }"
            href="/chart-of-accounts/import"
            >Imports</b-link
          >
          <b-link
            v-if="financial_management_import_coa"
            class="collapse-item"
            :class="{ active: coaReconcile }"
            href="/chart-of-accounts/reconcile"
            >COA Reconcile</b-link
          >
          <b-link
            v-if="financial_management_import_coa"
            class="collapse-item"
            :class="{ active: coaMerge }"
            href="/chart-of-accounts/merge-coa"
            >Merge COA</b-link
          >
          <b-link class="collapse-item" v-if="coa_trans" :class="{ active: coaTransactions }"
            href="/chart-of-accounts/transactions">
            COA Transactions
          </b-link>
          <!-- <b-link class="collapse-item" :class="{ active: coasubImports }" href="/chart-of-accounts/sub/import">COASub Imports</b-link> -->
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider d-none d-md-block" v-if="userManagementSectionVisible" />

    <!-- Heading -->
    <div class="sidebar-heading" v-if="userManagementSectionVisible">user management</div>

    <!-- User Management -->
    <b-nav-item v-b-toggle.collapse-2 v-if="userManagementSectionVisible" :class="{ active: users }">
      <font-awesome-icon :icon="['fas', 'user']" /><span>Users</span>
      <b-collapse :visible="userVisible" id="collapse-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="user_management_add"
            class="collapse-item"
            :class="{ active: addUsers }"
            href="/users/create"
            >Create User</b-link
          >
          <b-link
            v-if="user_management_view"
            class="collapse-item"
            :class="{ active: allUsers }"
            href="/users"
            >All Users</b-link
          >
          <b-link
            v-if="permission_management_edit"
            class="collapse-item"
            :class="{ active: permissions }"
            href="/users/permissions"
            >Roles / Permissions</b-link
          >
          <b-link
            v-if="user_management_view"
            class="collapse-item"
            :class="{ active: attendance }"
            href="/users/attendance"
            >Attendance</b-link
          >
          <b-link
            v-if="audit_trail"
            class="collapse-item"
            :class="{ active: audit }"
            href="/users/audit"
            >Audit</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>
    
    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block" v-if="userManagementSectionVisible" />

    <div class="sidebar-heading" v-if="settingsSectionVisible">Settings</div>

    <b-nav-item v-b-toggle.collapse-10 :class="{ active: branch }" v-if="system_management_view_branch">
      <font-awesome-icon :icon="['fas', 'code-branch']" /><span>Branches</span>
      <b-collapse id="collapse-10" :visible="branchVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="system_management_add_branch"
            class="collapse-item"
            :class="{ active: addBranch }"
            href="/branch/create"
            >Create Branch</b-link
          >
          <b-link
            v-if="system_management_view_branch"
            class="collapse-item"
            :class="{ active: allBranch }"
            href="/branch"
            >All Branches</b-link
          >
          <b-link
            v-if="system_management_view_branch"
            class="collapse-item"
            :class="{ active: importRegion }"
            href="/region/imports"
            >Imports</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>
    <hr class="sidebar-divider" v-if="system_management_view_institution" />
    <!-- Insititute Details -->
    <li class="nav-item" :class="{ active: institution }" v-if="system_management_view_institution">
      <a class="nav-link" href="/institution">
        <font-awesome-icon :icon="['fas', 'university']" />
        <span>Insitution Details</span>
      </a>
    </li>

    <hr class="sidebar-divider" v-if="system_management_view_financial_year" />
    <!-- Financial Year -->
    <li class="nav-item" :class="{ active: financial_year }" v-if="system_management_view_financial_year">
      <a class="nav-link" href="/financial-year">
        <font-awesome-icon :icon="['fas', 'calendar-week']" /><span>Financial Years</span>
      </a>
    </li>

    <hr class="sidebar-divider" v-if="settingsDividerBeforeProductTypesVisible" />
    <!-- Product Types -->
    <b-nav-item
      v-b-toggle.collapse-11
      :class="{ active: accType }"
      v-if="productTypesVisible"
    >
      <font-awesome-icon :icon="['fas', 'user-circle']" /><span>Product Types</span>
      <b-collapse id="collapse-11" :visible="accTypeVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link
            v-if="account_management_add"
            class="collapse-item"
            :class="{ active: addAccType }"
            href="/members/account-type/create"
            >Create
            Product Type</b-link>
          <b-link
            v-if="account_management_view"
            class="collapse-item"
            :class="{ active: allMemType }"
            href="/members/account-type"
            >All Product
            Types</b-link
          >
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" v-if="settingsDividerBeforeExcelExportsVisible" />
    <!-- Excel Export Details -->
    <li class="nav-item" :class="{ active: institution }" v-if="excelExportsVisible">
      <a class="nav-link" href="/settings/excel/export">
        <font-awesome-icon :icon="['fas', 'file-excel']" />
        <span>Excel Exports</span>
      </a>
    </li>

    <hr v-if="api_key" class="sidebar-divider" />
    <!-- Account type -->
    <b-nav-item v-b-toggle.collapse-12 v-if="api_key" :class="{ active: api }">
      <font-awesome-icon :icon="['fas', 'key']" /><span>API Key</span>
      <b-collapse id="collapse-12" :visible="apiVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: apiKey }" href="/settings/generate/apikey">Generate API
            Key</b-link>
          <!-- <b-link class="collapse-item" :class="{ active: allMemType }" href="/members/account-type">All Product
            Types</b-link> -->
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" v-if="settingsDividerBeforeSmsVisible" />

    <!-- SMS -->
    <li class="nav-item" :class="{ active: sms }" v-if="smsVisible">
      <a class="nav-link" href="/settings/sms">
        <font-awesome-icon :icon="['fas', 'envelope']" />
        <span>Sms</span>
      </a>
    </li>

    <!-- AI -->
     <hr class="sidebar-divider d-none d-md-block" v-if="aiSectionVisible" />
    <!-- Heading -->
    <div class="sidebar-heading" v-if="aiSectionVisible">AI</div>
    <!-- AI Document -->
    <li class="nav-item" :class="{ active: aiUpload }">
      <a class="nav-link" href="/ai/documentUpload">
        <font-awesome-icon :icon="['fas', 'user']" /><span>Upload Document</span>
      </a>
    </li>

    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block" v-if="reportsSectionVisible" />
    <!-- Heading -->
    <div class="sidebar-heading" v-if="reportsSectionVisible">Reports</div>
    <!-- Reports -->
    <li class="nav-item" :class="{ active: reports }" v-if="reportsSectionVisible">
      <a class="nav-link" href="/reports">
        <font-awesome-icon :icon="['fas', 'book']" /><span>Reports</span>
      </a>
    </li>

    <!-- transactions -->
    <!-- <b-nav-item v-b-toggle.collapse-6 :class="{ active: transactions }">  
        <font-awesome-icon :icon="['fas', 'exchange-alt']" /><span>Transactions</span>
        <b-collapse id="collapse-6" :visible="transactionsVisible" class="mt-2">
            <div class="py-2 collapse-inner" @click.stop>
                <b-link class="collapse-item" :class="{ active: deposit }"  href="/deposit">Deposit</b-link>
                <b-link class="collapse-item" :class="{ active: withdrawals }"  href="/withdrawal">Withdrawals</b-link>
            </div>
        </b-collapse>
    </b-nav-item> -->
  </ul>
  <!-- End of Sidebar -->
</template>
<script>
import ApiService from "@/core/services/api.service";
import { decryptData } from '@/crypto';
import { hasAnyPermission, hasPermission } from '@/helper';
import CustomTooltip from "@/views/components/CustomTooltip.vue";
export default {

  name: "SidebarView",
  // This are properties for active sidebar
  props: [
    "home",
    "users",
    "allUsers",
    "addUsers",
    "userVisible",
    "roles",
    "permissions",
    "branch",
    "branchVisible",
    "addBranch",
    "allBranch",
    "members",
    "memberVisible",
    "addMember",
    "allMember",
    "allAccountTypes",
    "accounts",
    "allCoa",
    "accountsVisible",
    "loan",
    "allLoans",
    "loanVisible",
    "loanCal",
    "loanScheme",
    "deposit",
    "withdrawal",
    "memacc",
    "memaccVisible",
    "addMemAcc",
    "allMemAcc",
    "memberImport",
    "transVisible",
    "operation",
    "operationsVisible",
    "allTransaction",
    "bulkTransaction",
    'bulkWithdrawals',
    "transaction",
    "depositTransaction",
    "withdrawalTransaction",
    "addLoan",
    "repayLoan",
    "accType",
    "addAccType",
    "allMemType",
    "accTypeVisible",
    "institution",
    "financial_year",
    "reports",
    "fixed_deposit",
    "voucher",
    "voucherVisible",
    "addVoucher",
    "voucherIndex",
    "journal",
    "journalVisible",
    "addJournal",
    "addOpeningOrClosingJournal",
    "journalIndex",
    "standing_order",
    "mobile",
    "journalTransferIndex",
    "loanImports",
    "coasubImports",
    "coaImports",
    "importRegion",
    "importMembers",
    "fdScheme",
    "transactionImports",
    "attendance",
    "operationImport",
    "termDepositsReports",
    "termTransactionsReports",
    "apiKey",
    "api",
    "apiVisible",
    "coaReconcile",
    'journalImport',
    'loanTransaction',
    "audit",
    "coaTransactions",
    "coaMerge",
    "fixed_deposit_trans",
    "roTransfer",
    "chequeProcessing",
    "sms",
    "balanceTransferBulk",
    "commission",
    "commissionVisible",
    "commissionSetup",
    "commissionPay",
    "interestDividend",
    "interestDividendVisible",
    "interestSetup",
    "interestPay",
    "fixedAssets",
    "fixedAssetsVisible",
    "assets",
    "assetCategories",
    "assetRegisterReport",
    "assetMovementHistoryReport",
    "depreciationScheduleReport",
    "nbvPerBranchReport",
    "disposedAssetsReport",
    "cashier",
    "cashierVisible",
    "cdc",
    "otherPaymentReceipts",
    "aiUpload",
    "budgets",
    "budgetsVisible",
    "budgetsList",
    "budgetsCreate",
    "budgetsLines",
    "budgetsApprovals",
    "budgetsDashboard"
  ],
  components: {
    CustomTooltip
  },
  data() {
    return {
      memberData: {
        approved_customer_count: 0,
        pending_customer_count: 0,
        rejected_customer_count: 0,
        male: 0,
        female: 0,
        group: 0,
        corporate: 0,
      },
      productData: {
        account: {
          pending: 0,
          active: 0,
          dormant: 0,
        },
        dailySavings: {
          male: 0,
          female: 0,
          total: 0
        },
        memberSavings: {
          male: 0,
          female: 0,
          total: 0
        }
      },
      depositAndWithdrawalData: {
        count: {
          pending: 0,
          completed: 0,
          reversed: 0
        },
        value: {
          pending: 0,
          completed: 0,
          reversed: 0
        }
      },
      fixed_deposit_summary: [],
      allLoansData: {
        pendingCount: 0,
        runningCount: 0,
        closedCount: 0,
        normalLoan: {
          count: 0,
          value: 0
        },
        businessLoan: {
          count: 0,
          value: 0
        }
      },
      allJournalsData: {
        Pending: {
          count: 0,
          value: 0
        },
        Approved: {
          count: 0,
          value: 0
        },

      },
      allVoucherData: {
        Pending: {
          count: 0,
          value: 0
        },
        Approved: {
          count: 0,
          value: 0
        },

      },
      user_permissions: JSON.parse(localStorage.getItem('user_permissions')) || [],
      noPendingMemberAccounts: 0,
      noApprovedMemberAccounts: 0,
      noRejectedMemberAccounts: 0,
      windowWidth: window.innerWidth,
      user_permissions: "",
      permission_state: {
        add_user: false,
        edit_user: false,
        view_user: false,
        roles_and_permissions: false,
        add_voucher: false,
        view_voucher: false,
        edit_voucher: false,
      },
      productSummary: {
        pending: 0,
        closed: 0,
      },
      audit_trail: false,
      user_branch: "",
      api_key: false,
      coa_trans: false,
      user_management_view: false,
      user_management_add: false,
      user_management_edit: false,
      role_management_view: false,
      permission_management_edit: false,
      member_management_view: false,
      member_management_add: false,
      member_management_edit: false,
      member_management_import: false,
      account_management_view: false,
      account_management_add: false,
      account_management_edit: false,
      transaction_management_view: false,
      transaction_management_deposit: false,
      transaction_management_withdrawal: false,
      transaction_management_all_view: false,
      transaction_management_import: false,
      journal_management_view: false,
      journal_management_add: false,
      journal_management_edit: false,
      journal_management_approve: false,
      journal_management_transfer: false,
      loan_management_view: false,
      loan_management_add: false,
      loan_management_calculator: false,
      loan_management_repayment: false,
      loan_management_import: false,
      voucher_management_view: false,
      voucher_management_add: false,
      voucher_management_edit: false,
      voucher_management_approve: false,
      system_management_view_branch: false,
      system_management_add_branch: false,
      system_management_edit_branch: false,
      financial_management_view_coa: false,
      financial_management_view_coa_type: false,
      financial_management_import_coa: false,
      system_management_view_control: false, //This
      system_management_view_financial: false, //This
      system_management_view_financial_year: false,
      operation_management_fixed_deposit_view: false,
      operation_management_import: false,
      system_management_view_institution: false,
      system_management_view_loans: false,
      loan_management_view_scheme: false,
      operation_management_standing_order_view: false,
      system_management_view_statistics: false,
      commission_management_setup: false,
      commission_management_pay: false,
      asset_register_manage: false,
      asset_register_reports: false,
      interest_management_setup: false,
      interest_management_pay: false,
      cdc_open_close: false,
      cdc_approve_reject: false,
      budgets_access: false,
      budgets_manage_access: false,
      budgets_approve_access: false,
      prevActiveID: null,
      prevActiveBool: null,
      loan_products: [],
      accountProduct: [],
      // Budget-scoped links require a selected budget. Keep optional:
      // when unset, links route to the budgets list.
      defaultBudgetId: "",
    };
  },
  created(){
    this.checkPermission();
  },
  watch: {
    '$store.state.user_permissions': {
          handler(newValue, oldValue) {
              if (newValue && newValue !== oldValue) {
                  this.checkPermission();
              }
          },
          deep: true
      }
  },
  mounted() {

    if (!this.mobile) {
      this.$nextTick(() => {
        const element = this.$refs.sidebar;
        window.addEventListener("resize", this.onResize);
        if (this.windowWidth < 768) {
          element?.classList?.add("toggled");
          // console.log(this.mobile);
        } else {
          element?.classList?.remove("toggled");
        }
      });
      this.user_branch = decryptData(localStorage.getItem("user_branch"));
    }
    this.checkPermission();
    this.getMemberInfo()

    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (isJustShown) {
        if (this.prevActiveID && this.prevActiveID !== collapseId) {
          // Close the previously active collapse
          this.$root.$emit('bv::toggle::collapse', this.prevActiveID);
        }
        // Update current active
        this.prevActiveID = collapseId;
      } else if (this.prevActiveID === collapseId) {
        // If the collapse was just hidden, clear the active ID
        this.prevActiveID = null;
      }

      // console.log('Active Collapse:', this.prevActiveID);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    dashboardVisible() {
      // If backend provides dashboard_view, respect it; otherwise keep dashboard visible.
      // This avoids "blank sidebar" for older deployments that don't send this permission.
      try {
        const set = this.$store?.getters?.permissionsSet;
        if (set && typeof set.has === "function" && set.size > 0) {
          return set.has("dashboard_view");
        }
      } catch (e) {
        // ignore
      }
      return true;
    },
    memberManagementSectionVisible() {
      return !!(
        this.member_management_view ||
        this.member_management_add ||
        this.member_management_edit ||
        this.member_management_import
      );
    },
    membersNavVisible() {
      // Keep Members group if any child link is visible
      return !!(
        this.member_management_view ||
        this.member_management_add ||
        this.member_management_import
      );
    },
    productsNavVisible() {
      // Member products group
      return !!(
        this.account_management_view ||
        this.account_management_add ||
        this.account_management_edit
      );
    },
    transactionsSectionVisible() {
      return !!(
        this.transaction_management_deposit ||
        this.transaction_management_withdrawal ||
        this.transaction_management_all_view ||
        this.transaction_management_import
      );
    },
    operationsSectionVisible() {
      return !!(
        this.operation_management_standing_order_view ||
        this.operation_management_fixed_deposit_view ||
        this.operation_management_import
      );
    },
    vouchersSectionVisible() {
      return !!(
        this.voucher_management_view ||
        this.voucher_management_add ||
        this.voucher_management_edit ||
        this.voucher_management_approve
      );
    },
    journalsSectionVisible() {
      return !!(
        this.journal_management_view ||
        this.journal_management_add ||
        this.journal_management_edit ||
        this.journal_management_approve ||
        this.journal_management_transfer
      );
    },
    loansSectionVisible() {
      return !!(
        this.loan_management_view ||
        this.loan_management_add ||
        this.loan_management_calculator ||
        this.loan_management_repayment ||
        this.loan_management_import
      );
    },
    userManagementSectionVisible() {
      return !!(
        this.user_management_view ||
        this.user_management_add ||
        this.user_management_edit ||
        this.permission_management_edit ||
        this.audit_trail ||
        this.role_management_view
      );
    },
    settingsSectionVisible() {
      // Settings area includes a mix of gated and always-on items in this sidebar.
      // Keep the heading only when at least one child is visible.
      return (
        this.system_management_view_branch ||
        this.system_management_view_institution ||
        this.system_management_view_financial_year ||
        this.productTypesVisible ||
        this.excelExportsVisible ||
        this.api_key ||
        this.smsVisible
      );
    },
    productTypesVisible() {
      // Best-available gating: Product Types relate to account/product management.
      return !!(this.account_management_view || this.account_management_add);
    },
    excelExportsVisible() {
      // No explicit permission exists in routes; gate to control permission for now.
      return !!this.system_management_view_control;
    },
    smsVisible() {
      // Gate by SMS permissions (new backend names), fallback to reports/control visibility.
      return (
        hasAnyPermission(["sms_request_send", "sms_approvals_manage"]) ||
        !!this.system_management_view_control
      );
    },
    settingsDividerBeforeProductTypesVisible() {
      // Render divider only when Product Types is visible AND there is a visible item above it.
      return (
        this.productTypesVisible &&
        (this.system_management_view_branch ||
          this.system_management_view_institution ||
          this.system_management_view_financial_year)
      );
    },
    settingsDividerBeforeExcelExportsVisible() {
      // Divider between Product Types and Excel Exports (or earlier settings items).
      return (
        this.excelExportsVisible &&
        (this.system_management_view_branch ||
          this.system_management_view_institution ||
          this.system_management_view_financial_year ||
          this.productTypesVisible)
      );
    },
    settingsDividerBeforeSmsVisible() {
      // Divider between Excel Exports/API Key and SMS.
      return (
        this.smsVisible &&
        (this.system_management_view_branch ||
          this.system_management_view_institution ||
          this.system_management_view_financial_year ||
          this.productTypesVisible ||
          this.excelExportsVisible ||
          this.api_key)
      );
    },
    aiSectionVisible() {
      // AI section currently always has at least one link.
      return true;
    },
    reportsSectionVisible() {
      return !!this.system_management_view_control;
    },
    budgetsSectionVisible() {
      return !!this.budgets_access;
    },
    budgetsApprovalsVisible() {
      return !!this.budgets_approve_access;
    },
    budgetsManageVisible() {
      return !!this.budgets_manage_access;
    },
    budgetsScopedId() {
      return this.defaultBudgetId || "";
    },
    budgetsLinesHref() {
      return this.budgetsScopedId ? `/budgets/${this.budgetsScopedId}/lines` : "/budgets";
    },
    budgetsApprovalsHref() {
      return this.budgetsScopedId ? `/budgets/${this.budgetsScopedId}/approvals` : "/budgets";
    },
    budgetsDashboardHref() {
      return this.budgetsScopedId ? `/budgets/${this.budgetsScopedId}/dashboard` : "/budgets";
    },
    memberHoverDetailDiplay() {
      return `
      Males : <strong>${this.displayCountingNumber(this.memberData.male)}</strong><br/>
      Females : <strong>${this.displayCountingNumber(this.memberData.female)}</strong><br/>
      Group : <strong>${this.displayCountingNumber(this.memberData.group)}</strong><br/>
      Corporate : <strong>${this.displayCountingNumber(this.memberData.corporate)}</strong><br/><br/>
      Total : <strong>${this.displayCountingNumber(this.getMemberTotal)}</strong>
      `;
    },
    // allProductHoverDetailDiplay() {
    //   return `
    //   <small class="fw-bolder">${"Daily Savings".toLocaleUpperCase()} </small> <br />
    //   <div class="ms-2">
    //     Males : <strong>${this.displayCountingNumber(this.productData.dailySavings.male)}</strong><br/>
    //     Females : <strong>${this.displayCountingNumber(this.productData.dailySavings.female)}</strong><br/><br/>
    //     Total : <strong>${this.displayCountingNumber(this.getTotal(this.productData.dailySavings.male, this.productData.dailySavings.female))}</strong>
    //   </div><br />
    //   <small class="fw-bolder">${"Member Savings".toLocaleUpperCase()} </small> <br />
    //   <div class="ms-2">
    //     Males : <strong>${this.displayCountingNumber(this.productData.memberSavings.male)}</strong><br/>
    //     Females : <strong>${this.displayCountingNumber(this.productData.memberSavings.female)}</strong><br/><br/>
    //     Total : <strong>${this.displayCountingNumber(this.getTotal(this.productData.memberSavings.male, this.productData.memberSavings.female))}</strong>
    //   </div><br />
    //     `
    // },
    allProductHoverDetailDiplay() {
      return `${this.accountProduct.map(index => '<small class="fw-bolder">' + index.name.toLocaleUpperCase() + '</small>' + '<br/>' + '<div class="ms-2">' + 'Male : ' + '<strong>' + index.male_count + '</strong>' + '<br/>' + 'Female : ' + '<strong>' + index.female_count + '</strong>' + '<br/>' + '</div>' + '<hr class="m-0"/>').join('')}`;
    },
    getMemberTotal() {
      const total = this.memberData.male + this.memberData.female + this.memberData.group + this.memberData.corporate;
      return total;
    },
    depositAndWithdrawalrHoverDetailDiplay() {
      return `
      Pending ${this.depositAndWithdrawalData.count.pending} : <strong>${this.displayNumber(this.depositAndWithdrawalData.value.pending)}</strong><br/>
      Completed ${this.depositAndWithdrawalData.count.completed} : <strong>${this.displayNumber(this.depositAndWithdrawalData.value.completed)}</strong><br/>
      Rejected ${this.depositAndWithdrawalData.count.reversed} : <strong>${this.displayNumber(this.depositAndWithdrawalData.value.reversed)}</strong><br/><br/>
      Total ${this.getTotal(this.getTotal(this.depositAndWithdrawalData.count.pending, this.depositAndWithdrawalData.count.completed), this.depositAndWithdrawalData.count.reversed)}
      : <strong>${this.displayNumber(this.getTotal(this.getTotal(this.depositAndWithdrawalData.value.pending, this.depositAndWithdrawalData.value.completed), this.depositAndWithdrawalData.value.reversed))}</strong>
      `;
    },
    fixedDepositHoverDetailDiplay() {
      let result = '';
      let totalCount = 0;
      let totalValue = 0;
      this.fixed_deposit_summary?.forEach(fd => {
        totalCount += fd.count || 0;
        totalValue += fd.value || 0;

        result +=  `${fd?.label ||''}: ${fd?.count || 0} : <strong>${this.displayNumber(fd?.value)}</strong><br/>`
      })

      return `
        ${result}
        <br/>
        Total ${totalCount} : <strong>${this.displayNumber(totalValue)}</strong>
      `;
    },
    // allLoansHoverDetailDiplay() {
    //   return `
    //   Normal Loan ${this.allLoansData.normalLoan.count} : <strong>${this.displayNumber(this.depositAndWithdrawalData.pending.value)}</small><br/>
    //   Business Loan ${this.allLoansData.businessLoan.count} : <strong>${this.displayNumber(this.depositAndWithdrawalData.completed.value)}</small><br/><br/>
    //   Total ${this.getTotal(this.allLoansData.normalLoan.count, this.allLoansData.businessLoan.count)}
    //   : <strong>${this.displayNumber(this.getTotal(this.allLoansData.normalLoan.value, this.allLoansData.businessLoan.value))}</small>
    //   `;
    // },
    allLoansHoverDetailDiplay() {
      return `
        ${this.loan_products.map(index => index.loan_product_name + ' ~ ' + index.count + ' : <strong>' + this.displayNumber(index.total_amount) + '</strong><br/> <hr class="my-1"/>').join('')}`;
    },
    allJournalsHoverDetailDiplay() {
      return `
      Pending ${this.allJournalsData.Pending.count} : <strong>${this.displayNumber(this.allJournalsData.Pending.value)}</strong><br/>
      Approved ${this.allJournalsData.Approved.count} : <strong>${this.displayNumber(this.allJournalsData.Approved.value)}</strong><br/><br/>
      Total ${this.getTotal(this.allJournalsData.Pending.count, this.allJournalsData.Approved.count)}
      : <strong>${this.displayNumber(this.getTotal(this.allJournalsData.Pending.value, this.allJournalsData.Approved.value))}</strong>
      `;
    },
    allVoucherHoverDetailDiplay() {
      return `
      Pending ${this.allVoucherData.Pending.count} : <strong>${this.displayNumber(this.allVoucherData.Pending.value)}</strong><br/>
      Approved ${this.allVoucherData.Approved.count} : <strong>${this.displayNumber(this.allVoucherData.Approved.value)}</strong><br/><br/>
      Total ${this.getTotal(this.allVoucherData.Pending.count, this.allVoucherData.Approved.count)}
      : <strong>${this.displayNumber(this.getTotal(this.allVoucherData.Pending.value, this.allVoucherData.Approved.value))}</strong>
      `;
    },
  },
  methods: {
    checkPermission() {
      // Map new backend permission names (2026) with fallback to legacy permission names
      this.audit_trail = hasAnyPermission(['user_management_audit']);
      this.api_key = hasAnyPermission(['api_keys_management', 'financial_management_api_key']);
      this.coa_trans = hasAnyPermission(['coa_management', 'financial_management_coa_transaction']);

      // Users / roles / permissions
      this.user_management_view = hasAnyPermission(['user_management_view']);
      this.user_management_add = hasAnyPermission(['user_management_add']);
      this.user_management_edit = hasAnyPermission(['user_management_edit']);
      this.role_management_view = hasAnyPermission(['role_management_view']);
      this.permission_management_edit = hasAnyPermission(['permission_management_edit']);

      // Customers (Members)
      this.member_management_view = hasAnyPermission(['customers_management', 'member_management_view']);
      this.member_management_add = hasAnyPermission(['customers_management', 'member_management_add']);
      this.member_management_edit = hasAnyPermission(['customers_management', 'member_management_edit']);
      this.member_management_import = hasAnyPermission(['customers_management', 'member_management_import']);

      // Accounts / Products
      this.account_management_view = hasAnyPermission(['accounts_management', 'account_management_view']);
      this.account_management_add = hasAnyPermission(['accounts_management', 'account_management_add']);
      this.account_management_edit = hasAnyPermission(['accounts_management', 'account_management_edit']);

      // Transactions (baseline gating)
      const txView = hasAnyPermission(['transactions_view', 'transaction_management_view']);
      this.transaction_management_deposit = txView || hasAnyPermission(['transaction_management_deposit']);
      this.transaction_management_withdrawal = txView || hasAnyPermission(['transaction_management_withdrawal']);
      this.transaction_management_all_view = txView || hasAnyPermission(['transaction_management_all_view']);
      this.transaction_management_import = txView || hasAnyPermission(['transaction_management_import']);
      this.transaction_management_view = hasAnyPermission([
        'transactions_view',
        'transaction_management_deposit',
        'transaction_management_withdrawal',
        'transaction_management_all_view',
        'transaction_management_import',
      ]);

      // Journals
      const jrView = hasAnyPermission(['journals_management', 'journal_management_view']);
      this.journal_management_view = jrView;
      this.journal_management_add = jrView || hasAnyPermission(['journal_management_add']);
      this.journal_management_edit = jrView || hasAnyPermission(['journal_management_edit']);
      this.journal_management_approve = jrView || hasAnyPermission(['journal_management_approve']);
      this.journal_management_transfer = jrView || hasAnyPermission(['journal_management_transfer']);

      // Loans
      const loanView = hasAnyPermission(['loans_management', 'loan_management_view']);
      this.loan_management_view = loanView;
      this.loan_management_add = loanView || hasAnyPermission(['loan_management_add']);
      this.loan_management_calculator = loanView || hasAnyPermission(['loan_management_calculator']);
      this.loan_management_repayment = loanView || hasAnyPermission(['loan_management_repayment']);
      this.loan_management_import = loanView || hasAnyPermission(['loan_management_import']);

      // Vouchers (no new mapping provided; keep legacy)
      this.voucher_management_view = hasAnyPermission(['voucher_management_view']);
      this.voucher_management_add = hasAnyPermission(['voucher_management_add']);
      this.voucher_management_edit = hasAnyPermission(['voucher_management_edit']);
      this.voucher_management_approve = hasAnyPermission(['voucher_management_approve']);

      // Settings / branches / institution / financial year
      const settingsView = hasAnyPermission(['settings_view']);
      const settingsManage = hasAnyPermission(['settings_manage']);
      this.system_management_view_branch = settingsView || hasAnyPermission(['system_management_view_branch']);
      this.system_management_add_branch = settingsManage || hasAnyPermission(['system_management_add_branch']);
      this.system_management_edit_branch = settingsManage || hasAnyPermission(['system_management_edit_branch']);
      this.system_management_view_institution = settingsView || hasAnyPermission(['system_management_view_institution']);
      this.system_management_view_financial_year = settingsView || hasAnyPermission(['system_management_view_financial_year']);

      // COA / Finance
      this.financial_management_view_coa = hasAnyPermission(['coa_management', 'financial_management_view_coa']);
      this.financial_management_view_coa_type = hasAnyPermission(['coa_management', 'financial_management_view_coa_type']);
      this.financial_management_import_coa = hasAnyPermission(['coa_management', 'financial_management_import_coa']);

      // Reports (Controls / Loans / Financials)
      this.system_management_view_control = hasAnyPermission([
        'reports_controls_view',
        'reports_loans_view',
        'reports_financials_view',
        'cash_flow_reports_view',
        'system_management_view_control',
      ]);
      this.system_management_view_financial = hasAnyPermission(['reports_financials_view', 'system_management_view_financial']);

      // Operations / Investments
      const inv = hasAnyPermission(['investments_management', 'operation_management_fixed_deposit_view']);
      this.operation_management_fixed_deposit_view = inv;
      this.operation_management_standing_order_view = hasAnyPermission(['investments_management', 'operation_management_standing_order_view']);
      this.operation_management_import = hasAnyPermission(['investments_management', 'operation_management_import']);

      // Commissions / Interest
      this.commission_management_setup = hasAnyPermission(['commission_management_setup']);
      this.commission_management_pay = hasAnyPermission(['commission_management_pay']);
      this.interest_management_setup = hasAnyPermission(['interest_management_setup']);
      this.interest_management_pay = hasAnyPermission(['interest_management_pay']);

      // Fixed assets
      this.asset_register_manage = hasAnyPermission(['asset_register_manage']);
      this.asset_register_reports = hasAnyPermission(['asset_register_reports']);

      // CDC
      this.cdc_open_close = hasAnyPermission(['cdc_open_close']);
      this.cdc_approve_reject = hasPermission('cdc_approve_reject');

      // Budgets module permissions (from /api/v1/users/permissions)
      this.budgets_manage_access = hasPermission("budgets_manage");
      this.budgets_approve_access = hasPermission("budgets_approve_lock");
      this.budgets_access =
        this.budgets_manage_access ||
        this.budgets_approve_access ||
        hasPermission("dashboard_view");
    },
    closeTabs() {
      this.memaccVisible = false
      this.userVisible = false;
      this.branchVisible = false;
      this.memberVisible = false;
      this.accountsVisible = false;
      this.loanVisible = false;
      this.memaccVisible = false;
      this.transVisible = false;
      this.operationsVisible = false;
      this.accTypeVisible = false;
      this.voucherVisible = false;
      this.journalVisible = false;

      console.log("called")
    },
    getMemberInfo() {
      this.checkPermission()
      ApiService.get("status-summary")
        .then(response => {
          this.memberData = response.data.customers
          // console.log(this.memberData);

          // All Loans data for hover
          this.allLoansData.runningCount = response.data.loans.running_loan_count
          this.allLoansData.pendingCount = response.data.loans.pending_loan_count
          this.allLoansData.closedCount = response.data.loans.closed_loan_count

          // Journal Data for hover
          this.allJournalsData.Approved.count = response.data.journals.approved_journal_count
          this.allJournalsData.Approved.value = response.data.journals.approved_journal_value
          this.allJournalsData.Pending.count = response.data.journals.pending_journal_count
          this.allJournalsData.Pending.value = response.data.journals.pending_journal_value

          // Journal Data for hover
          this.allVoucherData.Approved.count = response.data.vouchers.approved_voucher_count
          this.allVoucherData.Approved.value = response.data.vouchers.approved_voucher_value
          this.allVoucherData.Pending.count = response.data.vouchers.pending_voucher_count
          this.allVoucherData.Pending.value = response.data.vouchers.pending_voucher_value

          this.loan_products = response.data?.loan_products;

          this.fixed_deposit_summary = response.data.fixed_deposit;

          console.log("Fixed Deposit",this.fixed_deposit_summary)

          this.accountProduct = response.data.products;

          this.productSummary = response.data.product_summary;

          this.depositAndWithdrawalData = response.data.transaction_summary;

        }).catch((err) => {
          console.log(err)
          return [];  // Return an empty array in case of error to prevent the table from breaking
        });
    },
    statusBadge(state) {
      if (state === 'Approved') {
        return 'badge akkurate-blue'
      } else if (state === 'Pending') {
        return 'badge akkurate-orange'
      } else if (state === 'Rejected') {
        return 'badge akkurate-danger-bg'
      }
    },

    getTotal(a, b) {
      return a + b;
    }
  }

};
</script>